import { DuAuthenticationUtilities } from '@driscollsinc/driscolls-react-utilities';
// this might not be required just keeping it here for now
export const USER_ROLES_TO_GROUP_MAP = {
    Admin: 'SF_Admin',
    'Master Planner': 'SF_MasterPlanner',
    'Regional Forecaster': 'SF_Regional',
    'National Forecaster': 'SF_National'
};

let _cachedToken = null;
let _cachedRole = '';

const userRole = (token) => {
    // Return cached role if token hasn't changed — avoids JWT decode on every call
    if (token && token === _cachedToken) {
        return _cachedRole;
    }

    var allGroups = DuAuthenticationUtilities.GetGroups(token) || [];

    var allAppGroups = window.config.OKTA_ALL || [];

    var matchedGroups =
        allGroups.filter((group) => {
            return allAppGroups.includes(group);
        }) || [];

    var roleName = matchedGroups.find((group) => {
        return group.toLowerCase().includes('admin');
    })
        ? 'Admin'
        : matchedGroups.length > 0
        ? matchedGroups[0]
        : '';

    if (roleName.includes('-')) {
        roleName = roleName.substring(roleName.indexOf('-') + 1);

        while (roleName.includes('-')) {
            roleName = roleName.replace('-', ' ');
        }
    }

    _cachedToken = token;
    _cachedRole = roleName;
    return roleName;
};
export default userRole;
